import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router';
import { registerTool, unregisterTool } from 'shared/helpers/modelContext/toolRegistry';

const OpenCartTool = () => {
    const history = useHistory();
    const { pathname, search } = useLocation();
    
    // Use refs to get current values without triggering re-registration
    const historyRef = useRef(history);
    const pathnameRef = useRef(pathname);
    const searchRef = useRef(search);

    // Update refs when values change
    useEffect(() => {
        historyRef.current = history;
        pathnameRef.current = pathname;
        searchRef.current = search;
    }, [history, pathname, search]);

    useEffect(() => {
        const isRegistered = registerTool({
            name: "openCart",
            description: "Open the shopping cart to view items, proceed to cart, or manage cart contents.",

            inputSchema: {
                type: "object",
                properties: {},
                required: []
            },

            annotations: {
                title: "Open Cart",
                description: "Open the shopping cart to view and manage items",
            },

            execute: async () => {
                try {
                    // Create URL params and set showCart=1
                    const params = new URLSearchParams(searchRef.current);
                    params.set("showCart", '1');
                    
                    const url = pathnameRef.current + '?' + params.toString();
                    
                    // Navigate to the URL with showCart parameter
                    historyRef.current.push(url);

                    return {
                        content: [
                            {
                                type: "text",
                                text: "✅ Opening cart..."
                            }
                        ],
                        isError: false
                    };

                } catch (error: any) {
                    console.error('Open Cart Tool Error:', error);
                    
                    return {
                        content: [
                            {
                                type: "text",
                                text: `❌ Error opening cart: ${error.message}`
                            }
                        ],
                        isError: true
                    };
                }
            }
        });

        // Cleanup function
        return () => {
            if (isRegistered) {
                unregisterTool("openCart");
            }
        };

    }, []); // Empty dependency array - register only once

    return null;
};

export default OpenCartTool;
